// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__qfmuV","bigColWidth":"Table_bigColWidth__3zGCR","biggerColWidth":"Table_biggerColWidth__3QXiA","row":"Table_row__10FC0","col":"Table_col__pjApn"};